import { render, staticRenderFns } from "./orderExternalItemUpdateDialog.vue?vue&type=template&id=647ad550&"
import script from "./orderExternalItemUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./orderExternalItemUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports